(function () {
  const element = document.querySelector('[data-blanket-required-options]');
  if (!element || window.GiftsboxlyBlanketBundle) return;
  const config = JSON.parse(element.textContent);
  if (config.productId !== 15396820287725) return;
  const root = document.getElementById(config.bundleRootId);
  const section = element.closest('section');
  if (!root || !section) return;
  root.setAttribute('data-blanket-bundle-root', '');
  const definitions = [
    { key: 'pattern', id: '2001', label: 'Blanket Pattern', property: 'blanket-pattern' },
    { key: 'font', id: '2002', label: 'Name Font', property: 'name-font' },
    { key: 'color', id: '2003', label: 'Name Color', property: 'name-color' }
  ];
  const recipients = Array.from({ length: 4 }, () => ({}));
  const materialOrder = ['Standard Fleece - 280 GSM', 'Thick Fleece - 340 GSM', 'Plush Sherpa - Fluffy Texture'];
  const pricingElement = document.querySelector('[data-blanket-price-labels]');
  const pricing = pricingElement ? JSON.parse(pricingElement.textContent) : {};
  let choices;
  let nameLimit = 12;
  let pending = false;
  let ready = false;
  let syncingVariants = false;

  function offer() {
    const input = root.querySelector('input[name="quantity"]:checked');
    return input && root.querySelector('.quantity-break[data-input="' + input.dataset.input + '"]');
  }

  function isActive() {
    return Number(offer()?.dataset.quantity || 1) > 1;
  }

  function rows() {
    return Array.from(offer()?.querySelectorAll('.quantity-break__selector-item') || []).filter(row => Number(row.dataset.selectIndex) > 0);
  }

  function firstVariant() {
    const picker = document.getElementById(config.pickerId);
    const options = Array.from(picker?.querySelectorAll('.product-form__input') || []).map(group => group.querySelector('select, input:checked')?.value);
    return config.variants.find(variant => variant.options.every((value, i) => value === options[i]));
  }

  function firstRecipient() {
    const plugin = document.querySelector('[data-option-set-id="' + config.optionSetId + '"]');
    const recipient = { name: (plugin?.querySelector('[data-option-id="2004"] input[type="text"]')?.value || '').trim() };
    definitions.forEach(definition => {
      recipient[definition.key] = plugin?.querySelector('[data-option-id="' + definition.id + '"] .po-imageOption-checked')?.closest('.po-imageOption-container')?.querySelector('img')?.alt;
    });
    return recipient;
  }

  function cartItem(variant, recipient) {
    return {
      id: variant.id,
      quantity: 1,
      properties: { 'blanket-pattern': recipient.pattern, 'name-font': recipient.font, 'name-color': recipient.color, name: recipient.name }
    };
  }

  function priceForOffer(item) {
    if (!ready || item.closest('[data-blanket-bundle-root]') !== root || typeof formatMoney !== 'function') return '';
    const first = firstVariant();
    if (!first) return '';
    const quantity = Number(item.dataset.quantity);
    let total = 0;
    for (let index = 0; index < quantity; index++) {
      const options = index === 0 ? first.options : recipients[index]?.variantOptions || first.options;
      const variant = config.variants.find(candidate => candidate.options.every((value, i) => value === options[i]));
      if (variant?.price == null) return '';
      total += variant.price;
    }
    const price = Math.max(0, total * Number(item.dataset.percentageLeft || 1) - Number(item.dataset.fixedDiscount || 0));
    const template = item.querySelector('.quantity-break__price')?.dataset.text;
    if (!template || (!template.includes('[price]') && !template.includes('[price_each]'))) return '';
    const rendered = template.replace(/\[price\]/g, formatMoney(price, root.dataset.moneyFormat, true)).replace(/\[price_each\]/g, formatMoney(price / quantity, root.dataset.moneyFormat, true));
    return new DOMParser().parseFromString(rendered, 'text/html').body.textContent.trim();
  }

  function resolveVariant(row) {
    const options = Array.from(row.querySelectorAll('.quantity-break__variant-select')).map(select => select.value);
    return config.variants.find(variant => variant.options.length === options.length && variant.options.every((value, i) => value === options[i]));
  }

  function materialRank(value) {
    const rank = materialOrder.indexOf(value);
    return rank < 0 ? materialOrder.length : rank;
  }

  function sortMaterialOptions(select) {
    const selected = select.value;
    Array.from(select.options).sort((a, b) => materialRank(a.value) - materialRank(b.value)).forEach(option => select.appendChild(option));
    select.value = selected;
  }

  function updateSizeLabels(row) {
    const selects = row.querySelectorAll('.quantity-break__variant-select');
    const style = selects[0];
    const size = selects[1];
    if (!style || !size) return;
    Array.from(style.options).forEach(option => {
      const label = pricing.styles?.[option.value];
      if (!label) return;
      const choice = pricing.materialChoices?.[option.value];
      const surcharge = label.match(/\s*\((\+[^)]+)\)\s*$/)?.[0] || '';
      const description = choice ? label.replace(/\s*\((\+[^)]+)\)\s*$/, '') + ' - ' + choice + surcharge : label;
      if (option.textContent !== description) option.textContent = description;
    });
    const materialContext = row.querySelector('[data-bundle-material-context]');
    const materialDetail = pricing.materialDetails?.[style.value] || '';
    if (materialContext && materialContext.textContent !== materialDetail) materialContext.textContent = materialDetail;
    if (materialContext) materialContext.hidden = !materialDetail;
    const materialDisplay = row.querySelector('[data-bundle-material-display]');
    if (materialDisplay) {
      const parts = style.value.split(' - ');
      const label = pricing.styles?.[style.value] || '';
      const values = {
        value: materialDetail ? style.value : parts[0],
        caption: materialDetail || parts.slice(1).join(' - '),
        surcharge: label.match(/\((\+[^)]+)\)\s*$/)?.[1] || ''
      };
      Object.entries(values).forEach(([part, text]) => {
        const target = materialDisplay.querySelector('[data-bundle-material-' + part + ']');
        if (target.textContent !== text) target.textContent = text;
        if (part === 'surcharge') target.hidden = !text;
      });
      materialDisplay.hidden = !style.value;
      style.toggleAttribute('data-bundle-material-ready', Boolean(style.value));
    }
    const sizes = pricing.sizes?.[style.value] || {};
    Array.from(size.options).forEach(option => {
      const detail = pricing.sizeDetails?.[option.value];
      if (!detail || option.disabled) return;
      const surcharge = sizes[option.value]?.surcharge;
      const label = option.value + ' - ' + detail + (surcharge ? ' (' + surcharge + ')' : '');
      if (option.textContent !== label) option.textContent = label;
    });
    const context = row.querySelector('[data-bundle-size-context]');
    const detail = pricing.sizeDetails?.[size.value] || '';
    if (context && context.textContent !== detail) context.textContent = detail;
    const display = row.querySelector('[data-bundle-size-display]');
    if (display) {
      const value = display.querySelector('[data-bundle-size-value]');
      const caption = display.querySelector('[data-bundle-size-caption]');
      const surcharge = display.querySelector('[data-bundle-size-surcharge]');
      const extra = sizes[size.value]?.surcharge || '';
      if (value.textContent !== size.value) value.textContent = size.value;
      if (caption.textContent !== detail) caption.textContent = detail;
      if (surcharge.textContent !== extra) surcharge.textContent = extra;
      surcharge.hidden = !extra;
      display.hidden = !size.value;
      size.toggleAttribute('data-bundle-size-ready', Boolean(size.value));
    }
  }

  function makeVariantDisplay(control, kind) {
    const display = document.createElement('div');
    display.className = 'blanket-bundle-choice-display blanket-bundle-' + kind + '-display';
    display.setAttribute('data-bundle-' + kind + '-display', '');
    display.setAttribute('aria-hidden', 'true');
    display.hidden = true;
    ['value', 'caption', 'surcharge'].forEach(part => {
      const text = document.createElement('span');
      text.className = 'blanket-bundle-choice-' + part;
      text.setAttribute('data-bundle-' + kind + '-' + part, '');
      display.appendChild(text);
    });
    control.appendChild(display);
  }

  function prepareVariantFields(row, offerKey, index) {
    const number = row.querySelector('.quantity-break__selector-item__number');
    if (number) {
      number.id = config.bundleRootId + '-' + offerKey + '-' + index + '-heading';
      number.textContent = 'Blanket #' + (index + 1);
      row.setAttribute('role', 'group');
      row.setAttribute('aria-labelledby', number.id);
    }
    row.querySelectorAll(':scope > .select').forEach((control, position) => {
      const select = control.querySelector('.quantity-break__variant-select');
      if (position === 0) sortMaterialOptions(select);
      const field = document.createElement('div');
      field.className = 'blanket-bundle-variant-field';
      const label = document.createElement('label');
      label.className = 'blanket-bundle-field-label';
      select.id = config.bundleRootId + '-' + offerKey + '-' + index + '-variant-' + position;
      label.htmlFor = select.id;
      label.textContent = position === 0 ? 'Material' : 'Size';
      control.before(field);
      field.append(label, control);
      makeVariantDisplay(control, position === 0 ? 'material' : 'size');
      if (position === 0) {
        const context = document.createElement('p');
        context.className = 'blanket-bundle-material-context visually-hidden';
        context.dataset.bundleMaterialContext = '';
        context.id = select.id + '-context';
        context.hidden = true;
        select.setAttribute('aria-describedby', context.id);
        field.appendChild(context);
      }
      if (position === 1) {
        control.setAttribute('data-bundle-size-wrapper', '');
        const context = document.createElement('p');
        context.className = 'blanket-bundle-size-context';
        context.dataset.bundleSizeContext = '';
        context.id = select.id + '-context';
        select.setAttribute('aria-describedby', context.id);
        field.appendChild(context);
      }
    });
    updateSizeLabels(row);
  }

  function clearError(row) {
    row.querySelector('.blanket-bundle-error')?.remove();
    row.querySelectorAll('[aria-invalid="true"]').forEach(input => {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    });
  }

  function showError(row, message, input) {
    clearError(row);
    const error = document.createElement('p');
    error.className = 'blanket-bundle-error';
    error.id = config.bundleRootId + '-error-' + offer().dataset.input + '-' + row.dataset.selectIndex;
    error.setAttribute('role', 'alert');
    error.textContent = message;
    (row.querySelector('.blanket-bundle-fields') || row).appendChild(error);
    const target = input || row.querySelector('.quantity-break__variant-select');
    if (target) {
      target.setAttribute('aria-invalid', 'true');
      target.setAttribute('aria-describedby', error.id);
      target.focus({ preventScroll: true });
    }
    row.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }

  function validate() {
    const current = rows();
    if (!ready || current.length !== Number(offer()?.dataset.quantity) - 1) {
      const mainButton = document.getElementById(config.mainButtonId);
      const message = 'Personalization options are still loading. Please try again.';
      if (current[0]) showError(current[0], message);
      else mainButton?.closest('product-form')?.handleErrorMessage?.(message);
      return false;
    }
    if (!firstVariant()?.available) return false;
    current.forEach(clearError);
    for (let i = 0; i < current.length; i++) {
      const row = current[i];
      const index = Number(row.dataset.selectIndex);
      const variant = resolveVariant(row);
      if (!variant?.available) {
        showError(row, 'Please choose an available material and size for blanket #' + (index + 1) + '.');
        return false;
      }
      const input = row.querySelector('[data-bundle-field="name"]');
      const name = (input?.value || '').trim();
      if (!name || name.length > nameLimit) {
        showError(row, name ? 'Please use no more than ' + nameLimit + ' characters.' : 'Please enter the name for blanket #' + (index + 1) + '.', input);
        return false;
      }
      recipients[index].name = name;
    }
    return true;
  }

  function makeField(definition, index, offerKey) {
    const field = document.createElement('div');
    field.className = 'blanket-bundle-field blanket-bundle-field--' + definition.key;
    const id = config.bundleRootId + '-' + offerKey + '-' + index + '-' + definition.key;
    const label = document.createElement('div');
    label.className = 'blanket-bundle-field-label';
    label.id = id + '-label';
    label.textContent = definition.label + ' *';
    const control = document.createElement('div');
    control.className = 'blanket-bundle-swatches';
    control.setAttribute('role', 'radiogroup');
    control.setAttribute('aria-labelledby', label.id);
    control.setAttribute('aria-required', 'true');
    choices[definition.key].forEach(choice => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'blanket-bundle-swatch';
      button.dataset.bundleField = definition.key;
      button.dataset.bundleValue = choice.value;
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-label', choice.value);
      const selected = recipients[index][definition.key] === choice.value;
      button.setAttribute('aria-checked', String(selected));
      button.tabIndex = selected ? 0 : -1;
      const image = document.createElement('img');
      image.src = choice.image;
      image.alt = '';
      image.width = 86;
      image.height = 86;
      const caption = document.createElement('span');
      caption.textContent = choice.value;
      button.append(image, caption);
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        recipients[index][definition.key] = choice.value;
        syncRecipient(index);
      });
      control.appendChild(button);
    });
    control.addEventListener('keydown', event => {
      const buttons = Array.from(control.querySelectorAll('button'));
      const current = buttons.indexOf(event.target);
      let next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % buttons.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      buttons[next].click();
      buttons[next].focus();
    });
    field.append(label, control);
    return field;
  }

  function makeName(index, offerKey) {
    const field = document.createElement('div');
    field.className = 'blanket-bundle-field blanket-bundle-field--name';
    const id = config.bundleRootId + '-' + offerKey + '-' + index + '-name';
    const label = document.createElement('label');
    label.className = 'blanket-bundle-field-label';
    label.htmlFor = id;
    label.textContent = 'Name *';
    const input = document.createElement('input');
    input.className = 'blanket-bundle-input';
    input.id = id;
    input.type = 'text';
    input.autocomplete = 'off';
    input.maxLength = nameLimit;
    input.required = true;
    input.placeholder = 'Name for blanket #' + (index + 1);
    input.dataset.bundleField = 'name';
    input.value = recipients[index].name || '';
    const caption = document.createElement('div');
    caption.className = 'blanket-bundle-name-caption';
    const help = document.createElement('span');
    help.textContent = 'Up to ' + nameLimit + ' characters';
    const counter = document.createElement('span');
    counter.dataset.bundleCount = '';
    counter.textContent = input.value.length + '/' + nameLimit;
    caption.append(help, counter);
    input.addEventListener('input', () => {
      recipients[index].name = input.value;
      counter.textContent = input.value.length + '/' + nameLimit;
      clearError(input.closest('.quantity-break__selector-item'));
      syncRecipient(index, input);
    });
    field.append(label, input, caption);
    return field;
  }

  function syncRecipient(index, source) {
    root.querySelectorAll('.quantity-break__selector-item[data-select-index="' + index + '"] [data-bundle-field]').forEach(input => {
      if (input === source) return;
      const key = input.dataset.bundleField;
      if (key === 'name') {
        input.value = recipients[index].name || '';
        input.parentElement.querySelector('[data-bundle-count]').textContent = input.value.length + '/' + nameLimit;
      } else {
        const selected = input.dataset.bundleValue === recipients[index][key];
        input.setAttribute('aria-checked', String(selected));
        input.tabIndex = selected ? 0 : -1;
      }
    });
  }

  function initialize() {
    const plugin = document.querySelector('[data-option-set-id="' + config.optionSetId + '"]');
    if (!plugin) return false;
    choices = {};
    for (const definition of definitions) {
      const field = plugin.querySelector('[data-option-id="' + definition.id + '"]');
      const cards = Array.from(field?.querySelectorAll('.po-imageOption-container') || []);
      choices[definition.key] = cards.map(card => ({ value: card.querySelector('img')?.alt, image: card.querySelector('img')?.src })).filter(choice => choice.value && choice.image);
      if (!choices[definition.key].length) return false;
      const selected = field.querySelector('.po-imageOption-checked')?.closest('.po-imageOption-container')?.querySelector('img')?.alt;
      recipients.forEach(recipient => { recipient[definition.key] = selected || choices[definition.key][0].value; });
    }
    const nativeName = plugin.querySelector('[data-option-id="2004"] input[type="text"]');
    if (!nativeName) return false;
    nameLimit = Number(nativeName.maxLength > 0 ? nativeName.maxLength : 12);
    root.querySelectorAll('.quantity-break[data-quantity]').forEach(item => {
      if (Number(item.dataset.quantity) <= 1) return;
      item.querySelectorAll('.quantity-break__selector-item').forEach((row, index) => {
        if (index === 0) return;
        prepareVariantFields(row, item.dataset.input, index);
        const fields = document.createElement('div');
        fields.className = 'blanket-bundle-fields';
        definitions.forEach(definition => fields.appendChild(makeField(definition, index, item.dataset.input)));
        fields.appendChild(makeName(index, item.dataset.input));
        row.appendChild(fields);
      });
    });
    ready = true;
    updateMode();
    return true;
  }

  function updateMode() {
    section.setAttribute('data-blanket-bundle-active', String(ready && isActive()));
    const active = offer();
    root.querySelectorAll('.quantity-break').forEach(item => {
      item.querySelectorAll('[data-bundle-field]').forEach(input => { input.disabled = item !== active; });
    });
    syncVariants();
  }

  // Row #1 remains in the native price calculation, but its controls live above the bundle.
  function syncVariants() {
    if (!ready || syncingVariants || !isActive()) return;
    const first = firstVariant();
    if (!first) return;
    syncingVariants = true;
    try {
      offer().querySelectorAll('.quantity-break__selector-item').forEach(row => {
        const index = Number(row.dataset.selectIndex);
        const options = index === 0 ? first.options : recipients[index].variantOptions || first.options;
        const selects = Array.from(row.querySelectorAll('.quantity-break__variant-select'));
        selects.forEach((select, i) => { select.value = options[i]; });
        selects[0]?.dispatchEvent(new Event('change', { bubbles: true }));
        if (index > 0) updateSizeLabels(row);
      });
    } finally {
      syncingVariants = false;
    }
  }

  async function addToCart() {
    if (pending || !validate()) return;
    pending = true;
    const buttons = [config.mainButtonId, config.stickyButtonId].map(id => document.getElementById(id)).filter(Boolean);
    const main = document.getElementById(config.mainButtonId);
    const form = main?.closest('product-form');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    buttons.forEach(button => { button.setAttribute('aria-disabled', 'true'); button.classList.add('loading'); });
    main?.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    form?.handleErrorMessage?.();
    let added = false;
    try {
      const items = [cartItem(firstVariant(), firstRecipient()), ...rows().map(row => cartItem(resolveVariant(row), recipients[Number(row.dataset.selectIndex)]))];
      // Keep the theme's selected cart add-ons without duplicating existing lines.
      cart?.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach(upsell => {
        const exists = Array.from(cart.querySelectorAll('.cart-item')).some(item => item.classList.contains('cart-item--product-' + upsell.dataset.handle));
        if (upsell.dataset.selected === 'true' && upsell.dataset.id && !exists) items.push({ id: Number(upsell.dataset.id), quantity: 1 });
      });
      offer().querySelectorAll('.quantity-break__upsell').forEach(upsell => {
        const id = Number(upsell.dataset.product);
        if (upsell.dataset.selected === 'true' && id && !items.some(item => item.id === id)) items.push({ id, quantity: 1 });
      });
      const sectionIds = cart?.getSectionsToRender?.().map(item => item.id) || [];
      cart?.setActiveElement?.(main);
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: sectionIds, sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'These blankets could not be added. Please try again.');
      added = true;
      if (!cart?.renderContents || !sectionIds.length) {
        location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        return;
      }
      if (!result.sections || sectionIds.some(id => !result.sections[id])) {
        const rendered = await fetch(location.pathname + '?sections=' + sectionIds.join(','));
        if (!rendered.ok) throw new Error('Cart display refresh failed.');
        result.sections = await rendered.json();
      }
      cart.classList.remove('is-empty');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: result });
      cart.renderContents(result, false);
    } catch (error) {
      // A successful add must not be retried after only the drawer refresh fails.
      if (added) location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      else form?.handleErrorMessage?.(error.message || 'These blankets could not be added. Please try again.');
    } finally {
      pending = false;
      buttons.forEach(button => { button.removeAttribute('aria-disabled'); button.classList.remove('loading'); });
      main?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    }
  }

  root.addEventListener('change', event => {
    if (event.target.matches('input[name="quantity"]')) updateMode();
    if (!syncingVariants && event.target.matches('.quantity-break__variant-select')) {
      const row = event.target.closest('.quantity-break__selector-item');
      const index = Number(row.dataset.selectIndex);
      if (index > 0) recipients[index].variantOptions = Array.from(row.querySelectorAll('.quantity-break__variant-select')).map(select => select.value);
      clearError(row);
      updateSizeLabels(row);
    }
  });
  section.addEventListener('change', event => {
    if (event.target.closest('#' + config.pickerId) || event.target.matches('.product-variant-id')) requestAnimationFrame(syncVariants);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, syncVariants);
  window.GiftsboxlyBlanketBundle = { isActive, validate, addToCart, priceForOffer };
  if (!initialize()) {
    const observer = new MutationObserver(() => { if (initialize()) observer.disconnect(); });
    observer.observe(section, { childList: true, subtree: true });
  }
})();
